import { compose } from "@reduxjs/toolkit";
import { Col, message, Row, Skeleton, Tag } from "antd";
import dayjs from 'dayjs';
import i18next from "i18next";
import React from "react";
import { MainTitle, NJVButton, NJVDatePicker, NJVSelect, NJVTable } from "../../components/core-component";
import { SvgExcelOutlined, SvgPdfOutlined, SvgPngOutlined } from "../../components/custom-svgIcon";
import Theme, { Colors } from "../../components/theme";
import Api from "../../network/api";
import { HTTP_METHOD } from "../../network/httpMethod";
import { MEDIA_TYPE } from "../../network/mediaType";
import { ApiHandlerNoAuth, DownloadFileWithUrlNoAuth } from "../../network/network-manager";
import withRouter from "../../network/with-router";
import { Constant } from "../../core/constant";

class PublicInvoicePage extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            data: [],
            totalPagination: 0,
            page: 1,
            pageSize: Constant.pageSize,
            last_invoice: null,
            filterData: {},
            isDataFetching: false,
            isFilterAll: false,
            isFilterByDateRange: false,
            defaultFilter: 1,
            activeKey: 1
        }
    }

    componentDidMount() {
        const currentUrl = window.location.href;
        const index = currentUrl.indexOf('uniqueId=');
        let substring = null;
        if (index !== -1) {
            substring = currentUrl.substring(index + 'uniqueId='.length);
            this.setState({ filter_name: substring })
            this.fetchInvoice(0, substring)
        }
    }

    fetchInvoice = (pageNumber, uniqueId) => {
        const { page, pageSize } = this.state

        this.setState({
            isDataFetching: true
        })
        const requestParams = {
            "page": pageNumber ? pageNumber - 1 : page - 1,
            "size": pageSize,
            "uniqueId": uniqueId,
            "fromDate": "",
            "toDate": "",
        }
        ApiHandlerNoAuth({ url: Api.public_invoice, method: HTTP_METHOD.GET, mediaType: MEDIA_TYPE.JSON, requestParams })
            .then(response => {
                this.setState({
                    data: response.content,
                    last_invoice: response.content[0],
                    page: pageNumber ? pageNumber : 1,
                    totalPagination: response.totalElements
                })
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                this.setState({
                    isDataFetching: false,
                    isFilterAll: true,
                    isFilterByDateRange: false,
                })
            })
    }

    downloadInvoice = (downloadLink, invoice) => {
        downloadLink = downloadLink.replace(
            'https://d1jejw4ssai0l5.cloudfront.net/',
            'https://ninjavanstorages.s3.ap-southeast-1.amazonaws.com/'
        );
        const fileName = invoice.shipperName + "_Invoice_" + invoice.invoiceDate
        this.setState({
            isDownloading: true
        })
        DownloadFileWithUrlNoAuth(downloadLink, fileName)
            .then(() => { })
            .catch(() => { })
            .finally(() => {
                this.setState({
                    isDownloading: false,
                })
            });
    }

    isInvoiceDownload = (name, record, url) => {
        if (url) {
            this.downloadInvoice(url, record)
        }
        this.setState({
            currentInvoice: {
                name,
                id: record.id
            }
        })
    }

    filterBySpecific = (value) => {
        this.setState({
            defaultFilter: value
        })
        if (value === 1) {
            this.fetchInvoice(0, this.state.filter_name)
        } else if (value === 2) {
            const endDate = dayjs();
            const startDate = endDate.subtract(7, 'day');
            this.filterByDateRage(startDate.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD'),)
        } else if (value === 3) {
            const endDate = dayjs();
            const startDate = endDate.subtract(30, 'day');
            this.filterByDateRage(startDate.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD'),)
        }
    }

    filterByDateRage = async (startDate, endDate, pageNumber) => {
        const { page, pageSize, filter_name } = this.state

        try {
            this.setState({
                isDataFetching: true,
            })
            const requestParams = {
                "page": pageNumber ? pageNumber - 1 : page - 1,
                "size": pageSize,
                "uniqueId": filter_name,
                "fromDate": startDate || '',
                "toDate": endDate || '',
            }
            const response = await ApiHandlerNoAuth({ url: Api.public_invoice, method: HTTP_METHOD.GET, mediaType: MEDIA_TYPE.JSON, requestParams })

            if (response) {
                this.setState({
                    data: response.content,
                    last_invoice: response.content[0],
                    isDataFetching: false,
                    isFilterAll: false,
                    page: pageNumber ? pageNumber : 1,
                    isFilterByDateRange: true,
                    totalPagination: response.totalElements,
                })
            } else if (response && !response.success) {
                this.setState({
                    isDataFetching: false,
                    isFilterAll: true,
                    isFilterByDateRange: false,
                })
            }
        } catch (error) {
            this.setState({
                isDataFetching: false,
                isFilterAll: false,
                isFilterByDateRange: true,
            })
        }
    }

    search = () => {
        const { filterData } = this.state

        if (filterData) {

            if ((filterData.fromDate && !filterData.toDate) || (!filterData.fromDate && filterData.toDate)) {
                message.destroy()
                message.error("Invalid date")
                return
            }
            if (filterData.fromDate > filterData.toDate) {
                message.destroy()
                message.error("Invalid date")
                return
            }
            const startDate = filterData?.fromDate?.format("YYYY-MM-DD")
            const endDate = filterData?.toDate?.format("YYYY-MM-DD")
            this.setState({
                defaultFilter: null
            })
            this.filterByDateRage(startDate, endDate)
        }
    }

    updateFilterData = (key, value) => {
        let { filterData } = this.state
        filterData = {
            ...filterData,
            [key]: value
        }
        this.setState({
            filterData: filterData
        })
    }

    handlePaginationChange = (pageNumber, pageSize) => {
        const { isFilterAll, isFilterByDateRange, filterData, filter_name } = this.state
        if (isFilterAll) {
            this.fetchInvoice(pageNumber, filter_name);
        } else if (isFilterByDateRange && filterData && filterData.fromDate && filterData.toDate) {
            this.filterByDateRage(filterData.fromDate, filterData.toDate, pageNumber)
        }
    }

    render() {
        const { data, isDataFetching, totalPagination, page, pageSize, last_invoice, defaultFilter, currentInvoice, isDownloading } = this.state

        const columns = [
            {
                title: "No.",
                width: 30,
                key: 'index',
                render: (value, item, index) => <span>{(page - 1) * pageSize + index + 1}</span>,
            },
            {
                title: 'Invoice Date',
                key: 'invoiceDate',
                render: (invoice) => {
                    let invoiceDate = ""

                    if (invoice && invoice.invoiceDate) {
                        const convertedInvoiceDate = dayjs(invoice.invoiceDate, 'YYYY-MM-DD');
                        if (convertedInvoiceDate) {
                            invoiceDate = convertedInvoiceDate.format('DD-MMM-YYYY')
                        }
                    }
                    return <span>{invoiceDate}{last_invoice.createdDate === invoice.createdDate ? <Tag color='#B19478' style={{ marginLeft: 10 }}>Latest</Tag> : ''}</span>
                }
            }, {
                title: 'PDF',
                width: 50,
                align: 'center',
                render: (invoice) => (
                    <NJVButton size={'large'} type="text" shape="circle"
                        loading={currentInvoice?.name === 'PDF' && currentInvoice?.id === invoice.id && isDownloading}
                        onClick={() =>
                            this.isInvoiceDownload('PDF', invoice, invoice?.pdfDownloadUrl)}><SvgPdfOutlined width={23} height={23} color={Colors.primary} /></NJVButton>
                ),
            }, {
                title: 'Image',
                width: 50,
                render: (invoice) => (
                    <NJVButton size={'large'} type="text" shape="circle"

                        loading={currentInvoice?.name === 'PNG' && currentInvoice?.id === invoice.id && isDownloading}
                        onClick={() =>
                            this.isInvoiceDownload('PNG', invoice, invoice?.imgDownloadUrl)
                        }><SvgPngOutlined width={23} height={23} color={Colors.primary} /></NJVButton>
                ),
            },
            {
                title: 'Excel',
                width: 50,
                render: (invoice) => (
                    <NJVButton size={'large'} type="text" shape="circle"

                        loading={currentInvoice?.name === 'EXCEL' && currentInvoice?.id === invoice.id && isDownloading}
                        onClick={() =>
                            this.isInvoiceDownload('EXCEL', invoice, invoice?.excelDownloadUrl)
                        }><SvgExcelOutlined width={23} height={23} color={Colors.primary} /></NJVButton>
                ),
            }
        ]

        return (
            <Row style={{ marginTop: 20 }}>
                <Col lg={3} md={1} xs={1} sm={1} />
                <Col lg={18} md={22} xs={22} sm={22}>
                    <Row>
                        <Col span={24}>
                            <MainTitle label={'Invoice'} />
                        </Col>
                        {
                            last_invoice ?
                                <Col span={24} style={{ marginTop: 20 }}>
                                    <Row gutter={[16, 16]}>
                                        <Col span={24} style={{ fontWeight: 600 }}>Invoice No: {last_invoice.invoiceNo}</Col>
                                        <Col span={24} xs={24}>Invoice Date : {last_invoice.invoiceDate}</Col>
                                        <Col span={24} >Value : <span style={{ color: 'rgba(16, 194, 0, 1)', fontWeight: '700', fontSize: 15 }}>{parseInt(last_invoice.totalRemittance) - parseInt(last_invoice.creditAmount)}</span></Col>
                                    </Row>
                                </Col>
                                : <></>
                        }
                        <Col span={24} style={{ marginBottom: 20, marginTop: 20 }}>
                            <Row gutter={[16, 16]}>
                                <Col lg={6} md={6} sm={24} xs={24}>
                                    <NJVSelect
                                        size="large"
                                        style={{
                                            width: '100%'
                                        }}
                                        selectborder="#E6EFF5"
                                        selectprimary="#E6EFF5"
                                        placeholder="Select"
                                        value={defaultFilter}
                                        onChange={(value) => this.filterBySpecific(value)}
                                        options={[
                                            {
                                                'key': 1,
                                                'label': <>{i18next.t('order_billing')}</>,
                                                'value': 1
                                            }, {
                                                'key': 2,
                                                'label': 'Last 7 days',
                                                'value': 2
                                            }, {
                                                'key': 3,
                                                'label': 'Last 30 days',
                                                'value': 3
                                            }
                                        ]}
                                    />
                                </Col>

                                <Col lg={6} md={6} sm={24} xs={24}>
                                    <NJVDatePicker
                                        datepickerborder="#E6EFF5"
                                        datepickerprimary="#E6EFF5"
                                        onChange={(value) => this.updateFilterData('fromDate', value)}
                                        style={{ width: '100%' }}
                                        size="large"
                                        placeholder={i18next.t("from_date")} />
                                </Col>
                                <Col lg={6} md={6} sm={24} xs={24}>
                                    <NJVDatePicker
                                        datepickerborder="#E6EFF5"
                                        datepickerprimary="#E6EFF5"
                                        onChange={(value) => this.updateFilterData('toDate', value)}
                                        style={{ width: '100%' }}
                                        size="large"
                                        placeholder={i18next.t("to_date")} />
                                </Col>
                                <Col lg={6} md={6} sm={24} xs={24}>
                                    <NJVButton
                                        buttonprimary={Theme.colors.primary}
                                        size="large"
                                        style={{ width: '100%' }}
                                        type="primary" onClick={() => this.search()}>
                                        {i18next.t("search")}
                                    </NJVButton>
                                </Col>
                            </Row>
                        </Col>
                        <Col span={24}>
                            {
                                isDataFetching ?
                                    <Skeleton />
                                    :
                                    <NJVTable
                                        headerbgcolor="#F7F7F7"
                                        headerborderradius='0px'
                                        cellinline="6px"
                                        cellblock="6px"
                                        tableborder="#EAEAEA"
                                        rowKey={(record) => record.id}
                                        style={{ borderRadius: 0 }}
                                        pagination={{
                                            position: 'top' | 'bottom',
                                            total: totalPagination,
                                            current: page,
                                            onChange: this.handlePaginationChange,
                                            defaultPageSize: pageSize,
                                            showSizeChanger: false
                                        }}
                                        columns={columns} dataSource={data} />
                            }
                        </Col>
                    </Row>
                </Col>
            </Row>
        )
    }
}

export default compose(withRouter)(PublicInvoicePage)